import React, { useEffect } from 'react';
import './rebrand.css';
import { Nav } from './parts';
import { Audit, Examples, Faq, FitCheck, Hero, Process, Symptoms, WhyStall } from './sections';
import { Book } from './Book';
import Footer from './Footer';
import CookieBar from './CookieBar';
import MobileBookBar from './MobileBookBar';
import { FAQS } from './content';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent';

// The old site's global body style is dark; the rebrand pages paint the body paper-colored
// so overscroll/bounce areas match.
function usePaperBody() {
  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#F6F3ED';
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, []);
}

// FAQPage structured data, built from the same FAQ copy the page shows.
const FAQ_JSON_LD = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export function Home() {
  usePaperBody();
  return (
    <div className="rb">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: FAQ_JSON_LD }} />
      <Nav />
      <main>
        <Hero />
        <Symptoms />
        <WhyStall />
        <Audit />
        <Process />
        <Examples />
        <FitCheck />
        <Faq />
        <Book />
      </main>
      <Footer />
      <MobileBookBar />
      <CookieBar />
    </div>
  );
}

const PRIVACY_TITLE = 'Privacy Policy | Primeslink';
const PRIVACY_DESCRIPTION =
  "Primeslink's Privacy Policy — how we collect, use, and protect your information when you visit primeslink.com or use our AI consulting services.";

export function Privacy() {
  usePaperBody();
  useEffect(() => {
    const previousTitle = document.title;
    document.title = PRIVACY_TITLE;
    const descTag = document.querySelector('meta[name="description"]');
    const previousDescription = descTag ? descTag.getAttribute('content') : null;
    if (descTag) descTag.setAttribute('content', PRIVACY_DESCRIPTION);
    return () => {
      document.title = previousTitle;
      if (descTag && previousDescription !== null) descTag.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="rb">
      <Nav />
      <main className="pt-32 pb-24 px-5 sm:px-8">
        <div className="max-w-3xl mx-auto rb-card rb-legal p-8 md:p-12">
          <PrivacyPolicyContent />
        </div>
      </main>
      <Footer />
      <CookieBar />
    </div>
  );
}
